/**
 * Проверка обновлений открытой вкладки.
 *
 * Открытая вкладка живёт со своим кодом сколько угодно: после выкладки новой
 * версии человек продолжал работать на старой, пока сам не нажмёт Ctrl+F5 —
 * и не видел свежих правок. Здесь вкладка сама узнаёт о новой сборке
 * и предлагает обновиться.
 *
 * Как: при сборке рядом с файлами кладётся `version.json` с номером сборки
 * (см. vite.config.ts). Вкладка изредка спрашивает его и сравнивает со своим.
 */

/** Номер сборки, с которой работает эта вкладка (подставляет сборщик). */
declare const __APP_BUILD__: string | undefined;

export function currentBuildId(): string {
  try {
    return typeof __APP_BUILD__ === "string" ? __APP_BUILD__ : "";
  } catch {
    return "";
  }
}

export const VERSION_URL = "/version.json";
/** Как часто спрашивать сервер. Файл крошечный, но чаще незачем. */
export const VERSION_POLL_MS = 5 * 60 * 1000;

export async function fetchServerBuildId(
  fetchImpl: typeof fetch = fetch
): Promise<string | null> {
  try {
    const res = await fetchImpl(`${VERSION_URL}?t=${Date.now()}`, {
      cache: "no-store",
      credentials: "omit",
    });
    if (!res.ok) return null;
    const data = (await res.json()) as { build?: unknown };
    return typeof data.build === "string" && data.build ? data.build : null;
  } catch {
    // Нет сети или сервер недоступен — просто попробуем позже.
    return null;
  }
}

/** Вышла ли на сервере сборка новее той, что открыта. */
export function isOutdated(current: string, server: string | null): boolean {
  if (!server || !current) return false;
  return server !== current;
}
